import { MapsService } from './../../providers/maps.service';
import { AfterViewInit, Component, OnInit, EventEmitter, OnDestroy, Renderer2 } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { NavigationItem } from "../../models/navigationItem";
import { ActivatedRoute, Router } from "@angular/router";
import { FirebaseListObservable, FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { Hour } from "../../models/hour";
import { Location } from "@angular/common";
import { FormsService } from "../../providers/forms.service";
import { Form } from "../../models/forms";
import { Observable } from "rxjs/Observable";
import { isNullOrUndefined, isUndefined } from "util";
import { ScrollService } from "../../providers/scroll.service";
import { TextMessage } from "../../models/textMessage";
import { LoadingServiceProvider } from "../../providers/loading-service";
import { environment } from "../../../environments/environment";
import { ShortUrlService } from "../../providers/short-url.service";
import { MdSlideToggleChange } from '@angular/material';
import { AWSConnectorService } from 'ng2/app/providers/aws-connector';
import { HTMLRow } from '../../models/htmlRow';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/take';
import * as _ from 'lodash'

@Component({
  selector: 'app-view-location',
  templateUrl: './view-location.component.html',
  styleUrls: ['./view-location.component.css']
})
export class ViewLocationComponent implements OnInit, AfterViewInit, OnDestroy {
  key: string;
  locKey: string;
  location: FirebaseObjectObservable<LocationInfo>;
  clientData: Client;
  client: FirebaseObjectObservable<Client>;
  error: string;
  success: string;
  officeHours: FirebaseListObservable<Array<Hour>>;
  gateHours: FirebaseListObservable<Array<Hour>>;
  path: string;
  locationData: LocationInfo;
  oldLocationData: LocationInfo;
  locationOnboardingInfo;
  rowLayoutOptions = [
    { label: 'Image Left', value: 'imageLeft' },
    { label: 'Image Right', value: 'imageRight' },
    { label: 'Stacked Image Top', value: 'stackedImageTop' },
    { label: 'Stacked Image Bottom', value: 'stackedImageBottom' },
    { label: 'Image Only', value: 'imageOnly' },
    { label: 'HTML Only', value: 'htmlOnly' },
  ];

  sitelinkCredsValid: boolean = null;

  newHTMLRow: boolean;
  htmlRow: HTMLRow;
  selectedHTMLRow: HTMLRow;
  _htmlRows: string[] = [];
  private _dragulaSub: Subscription
  get htmlRows() { return this._htmlRows };
  set htmlRows(value: string[]) {
    this._htmlRows = value || [];
  };

  selectedLocation: EventEmitter<any>;

  prepayOptions = [
    { title: '1', value: 1 },
    { title: '2', value: 2 },
    { title: '3', value: 3 },
    { title: '5', value: 5 },
    { title: '4', value: 4 },
    { title: '6', value: 6 },
    { title: '7', value: 7 },
    { title: '8', value: 8 },
    { title: '9', value: 9 },
    { title: '10', value: 10 },
    { title: '11', value: 11 },
    { title: '12', value: 12 }
  ];

  claimAccountOptions = [
    { title: 'Unit # & Gate Code', value: 'gateCode' },
    { title: 'Unit # & Phone #', value: 'phoneNum' },
  ];

  options = {
    key: environment.froalaKey,
    placeholderText: 'Edit Your Content Here!',
    charCounterCount: true,
    htmlExecuteScripts: false,
    htmlRemoveTags: [],
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  };

  optionsNoSticky = {
    key: environment.froalaKey,
    placeholderText: 'Edit Your Content Here!',
    charCounterCount: true,
    htmlAllowedEmptyTags: ['div', 'textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.mdi'],
    toolbarSticky: false,
    htmlRemoveTags: [],
    htmlExecuteScripts: false,
    pasteDeniedAttrs: [],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'onclick'],
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'script', 'style'],
  };

  bulletinDropdownOptions = [
    { label: 'Rentals', value: 'rentals' },
    { label: 'Reservations', value: 'reservations' },
    { label: 'Payments', value: 'payments' },
    { label: 'Autopay Changes', value: 'autopay changes' },
    { label: 'Move Outs', value: 'move outs' }
  ];

  allForms: Observable<Array<Form>>;
  navItems: FirebaseListObservable<Array<NavigationItem>>;

  twilioNumbers = [
    { number: '18652192552', viewNumber: '(865) 219-2552' }
  ];

  numDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

  testSms = new TextMessage();
  date = new Date();
  availableUnits = 0;
  totalUnits = 0;
  occupancyRate: number;
  removeListener;

  constructor(
    public afService: FirebaseService,
    private route: ActivatedRoute,
    public locationAngular: Location,
    public forms: FormsService,
    private scroll: ScrollService,
    private loading: LoadingServiceProvider,
    private shortUrl: ShortUrlService,
    private mapsService: MapsService,
    private router: Router,
    private aws: AWSConnectorService,
    private renderer: Renderer2,
    public dragulaService: DragulaService,
  ) { }

  ngOnInit() {
    if (!this._htmlRows) {
      this._htmlRows = [];
    }
    this._dragulaSub = this.dragulaService.dropModel.subscribe(domStuff => this.save());

    this.route.params.subscribe((params) => {
      // console.log('params')
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.afService.clientKey = this.key;
      this.testSms.apiUrl = environment.textApi;
      this.testSms.facilityKey = this.key;
      this.testSms.monthYear = this.date.getMonth() + '-' + this.date.getFullYear();
      this.locationOnboardingInfo = null;
      this.client = this.afService.getClientInfo(this.key);
      this.navItems = this.afService.getFacilityNavItems(this.key, this.locKey);

      let sub = this.afService.getClientInfo(this.key).subscribe((clientData) => {
        if (sub && !sub.closed) {
          sub.unsubscribe();
        }
        this.clientData = clientData;
        let sub2 = this.aws.getObjectFromFirebase(this.clientData.code, `availableUnits/${ this.locKey }`).subscribe((avail: any) => {
          if (sub2 && !sub2.closed) {
            sub2.unsubscribe();
          }
          if (!isNullOrUndefined(avail)) {
            try {
              this.availableUnits = Object.keys(avail.availableUnitsByUnitId).length;
            }
            catch (error) {
              console.warn('Error caught setting this.availableUnits:', error);
            }
          }
          let sub3 = this.aws.getObjectFromFirebase(this.clientData.code, `allUnits/${ this.locKey }`).subscribe((units: any) => {
            if (sub3 && !sub3.closed) {
              sub3.unsubscribe();
            }
            this.totalUnits = 0;
            if (!isNullOrUndefined(units)) {
              for (let i in units) {
                if (units[i].isRentable == true) {
                  this.totalUnits++;
                }
              }
            }
            this.occupancyRate = 100 - ((this.availableUnits / this.totalUnits) * 100);
          });
        });


        if (!isNullOrUndefined(this.locKey)) {
          this.getLocationInfo();
        }
      });
    });

    this.removeListener = this.renderer.listen('window', 'keydown', (event: KeyboardEvent) => {
      if (event.ctrlKey && event.keyCode === 83) {
        this.afService.updateSettingsOnServer(this.clientData);
      }
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    this.removeListener();
    try {
      if (this.dragulaService) {
        this.dragulaService.destroy('html-rows-bag');
      }
      if (this._dragulaSub && !this._dragulaSub.closed) {
        this._dragulaSub.unsubscribe();
      }
    }
    catch (err) {
      console.warn('ngOnDestroy error caught:', err);
    }
  }


  save() {
    this.htmlRows = this._htmlRows;
    this.updateLocation();
  }

  changeSelectedLocation(location) {
    this.router.navigate([`clients/${ this.key }/location/${ location.$key }`]);
  }

  async getLocationInfo() {
    this.testSms.locationKey = this.locKey;
    this.path = '/clients/' + this.key + '/location/' + this.locKey;
    this.officeHours = this.afService.getLocationOfficeHours(this.key, this.locKey);
    this.gateHours = this.afService.getLocationGateHours(this.key, this.locKey);

    this.locationData = await this.afService.getLocationInfoPromise(this.key, this.locKey);
    let shouldUpdateLocation = false;

    if (isUndefined(this.locationData.showReserveUnitsOption)) {
      this.locationData.showReserveUnitsOption = true;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.locationBoxSlideshow.sliderUrls)) {
      this.locationData.locationBoxSlideshow.sliderUrls = [];
    }
    if (isUndefined(this.locationData.isAutoPayAtMoveIn)) {
      this.locationData.isAutoPayAtMoveIn = true;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.separatorTitle)) {
      this.locationData.separatorTitle = '';
      this.locationData.separatorText = '';
      this.locationData.featuresTitle = 'Location Features';
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.aboutLocationText)) {
      this.locationData.aboutLocationText = 'Here goes a little blurb about the specific location. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce mauris risus, mattis et nulla vestibulum, vehicula convallis ante.';
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.showInsuranceOptions)) {
      this.locationData.showInsuranceOptions = false;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.claimAccountType)) {
      this.locationData.claimAccountType = 'gateCode';
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.aboutLocationFeaturesArray)) {
      this.locationData.aboutLocationFeaturesArray = [];
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.locationsCustomSidebarArray)) {
      this.locationData.locationsCustomSidebarArray = [];
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.noGate)) {
      this.locationData.noGate = false;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.isSmsReminders)) {
      this.locationData.isSmsReminders = false;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.acceptPayments)) {
      this.locationData.acceptPayments = true;
      this.locationData.acceptPaymentsMessage = 'Payments are currently under maintenance. Please call the office to make a payment.';
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.hideRentals)) {
      this.locationData.hideRentals = false;
    }
    if (isUndefined(this.locationData.comingSoonInfo)) {
      this.locationData.comingSoonInfo = {
        headerDate: 'August 2021',
        title: 'Coming Soon to a City Near You',
        contactUsTitle: 'Contact Us Now',
        contactUsSubtitle: '',
        imageUrl: '',
        layout: [{
          label: 'Image Left',
          value: 'imageLeft'
        }],
        html: ''
      };
    }
    if (isUndefined(this.locationData.disableRentals)) {
      this.locationData.disableRentals = false;
      this.locationData.disableRentalsMessage = '';
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.htmlHomePageRows)) {
      this.locationData.htmlHomePageRows = [
        new HTMLRow()
      ];
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.generateRandomGateCode)) {
      this.locationData.generateRandomGateCode = false;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.parkingVariables)) {
      this.locationData.parkingVariables = false;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.noOffice)) {
      this.locationData.noOffice = true;
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.reservationFee)) {
      this.locationData.reservationFee = false;
      shouldUpdateLocation = true;
    }
    if (isNullOrUndefined(this.locationData.insightsHero)) {
      this.locationData.insightsHero = {
        title: this.locationData.name,
        subtitle: 'Storage Units in ' + this.locationData.address2
      }
    }
    if (isUndefined(this.locationData.locationBoxSlideshow)) {
      this.locationData.locationBoxSlideshow = {
        sliderUrls: [],
        showSliderArrows: false,
        sliderAutoPlay: true
      };
      shouldUpdateLocation = true;
    }
    if (isUndefined(this.locationData.smsData)) {
      this.locationData.smsData = {
        phoneNumber: '18652192552',
        dayRentIsDue: 1,
        daysBeforeDueToRemind: 5,
        showTotal: true,
        shortLinkUrl: '',
        linkUrl: ''
      };
      shouldUpdateLocation = true;
    }
    if (isNullOrUndefined(this.locationData.showSocialLinks)) {
      this.locationData.showSocialLinks = false;
      shouldUpdateLocation = true;
    }
    if (isNullOrUndefined(this.locationData.associationLogos)) {
      this.locationData.associationLogos = [];
    }
    if (isNullOrUndefined(this.locationData.prepayMonths)) {
      this.locationData.prepayMonths = 12;
      shouldUpdateLocation = true;
    }

    if (isUndefined(this.locationData.loginPage)) {
      this.locationData.loginPage = {
        metaTitle: "",
        metaDescription: ""
      };
      shouldUpdateLocation = true;
    }

    if (isUndefined(this.locationData.unitsPage)) {
      this.locationData.unitsPage = {
        metaTitle: "",
        metaDescription: ""
      };
      shouldUpdateLocation = true;
    }

    if (isUndefined(this.locationData.reviewsPage)) {
      this.locationData.reviewsPage = {
        pageTitle: this.locationData.name + ' Reviews',
        metaTitle: 'Reviews - ' + this.locationData.name + ' | ' + this.clientData.name,
        metaDescription: `${ 'Read reviews from ' + this.clientData.name + ' - ' + this.locationData.name + ' customers.' }`
      };
      shouldUpdateLocation = true;
    }

    if (isUndefined(this.locationData.unitFilters)) {
      this.locationData.unitFilters = {
        showClimate: true,
        showInside: true,
        showPowerOutlet: true,
        showUnitAlarm: true,
        showGroundFloor: true,
        showFeaturesFilters: true,
        useLocationUnitFilters: false
      };
      shouldUpdateLocation = true;
    }

    if (isUndefined(this.locationData.datePickerDisableDays)) {
      this.locationData.datePickerDisableDays = [false, false, false, false, false, false, false];
      shouldUpdateLocation = true;
    }

    // we don't need to update with an empty array
    if (isNullOrUndefined(this.locationData.socialLinks))
      this.locationData.socialLinks = [];

    if (this.locationData.smsData.linkUrl == '' || isUndefined(this.locationData.smsData.linkUrl)) {
      this.locationData.smsData.linkUrl = `${ this.clientData.siteUrl }/${ this.locKey }/customer-portal/login`;
    }

    this.oldLocationData = _.cloneDeep(this.locationData);

    if (shouldUpdateLocation) {
      this.updateLocation();
    }
  }

  copyFromHomeSlides(which?: string) {
    if (confirm('Are you sure?')) {
      if (which === 'locationHomeSlides') {
        this.afService.loadComponentSettings(this.key).take(1).subscribe((data: any) => {
          this.locationData.sliderUrls = data.sliderUrls;
          this.updateLocation();
        });
      }
      else {
        this.afService.loadComponentSettings(this.key).take(1).subscribe((data: any) => {
          this.locationData.locationBoxSlideshow.sliderUrls = data.sliderUrls;
          this.updateLocation();
        });
      }
    }
  }

  copyFromLocationSlides() {
    if (confirm('Are you sure?')) {
      this.locationData.locationBoxSlideshow.sliderUrls = this.locationData.sliderUrls;
      this.updateLocation();
    }
  }

  copyFromLocationBoxSlides() {
    if (confirm('Are you sure?')) {
      this.locationData.sliderUrls = this.locationData.locationBoxSlideshow.sliderUrls;
      this.updateLocation();
    }
  }

  copyBulletinSettings() {
    this.afService.getLocations(this.clientData).first(locations => !!locations).subscribe((locations: LocationInfo[]) => {
      let proms = [];
      for (let location of locations) {
        location.disabledBulletins = this.locationData.disabledBulletins;
        proms.push(this.afService.updateLocation(this.clientData, location));
      }
      Promise.all(proms).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    });
  }
  copyEmailColorSettings() {
    this.afService.getLocations(this.clientData).first(locations => !!locations).subscribe((locations: LocationInfo[]) => {
      let proms = [];
      for (let location of locations) {
        location.emailHex = this.locationData.emailHex;
        proms.push(this.afService.updateLocation(this.clientData, location));
      }
      Promise.all(proms).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    });
  }

  addFacilityFeatures() {
    if (this.locationData.featuresComponent) {
      for (let feature of this.locationData.featuresComponent) {
        this.locationData.aboutLocationFeaturesArray.push({ name: feature.name });
      }
    }
    else {
      for (let feature of this.clientData.components.features) {
        this.locationData.aboutLocationFeaturesArray.push({ name: feature.name });
      }
    }
  }

  saveSidebarSections() {
    for (let feature of this.locationData.locationsCustomSidebarArray) {
      feature.id = feature.title.replace(/\W+/g, '-').toLowerCase();
    }
    this.updateLocation();
  }

  getLatLong() {
    this.mapsService.getLatLong(this.locationData).toPromise().then(([mapsResponse, location]) => {
      this.locationData.latitude = mapsResponse.results[0].geometry.location.lat;
      this.locationData.longitude = mapsResponse.results[0].geometry.location.lng;
    });
  }

  fillSitelinkDemoDetails() {
    this.locationData.siteLinkCorpCode = 'CCTST';
    this.locationData.siteLinkLocationCode = 'Demo3';
    this.locationData.siteLinkLicenseKey = 'STORAGEPUG4T67WJN34F';
    this.locationData.siteLinkCorpUsername = 'Administrator:::STORAGEPUG4T67WJN34F';
    this.locationData.siteLinkLocationPw = 'Demo';
  }

  verifySitelinkCreds() {
    this.aws.verifySitelinkCreds(this.locationData.siteLinkCorpCode, this.locationData.siteLinkLocationCode, this.locationData.siteLinkCorpUsername, this.locationData.siteLinkLocationPw).toPromise()
      .then((data: any) => {
        console.log(data)
        this.sitelinkCredsValid = data.success;
      })
      .catch(e => {
        console.log("🚀 ~ file: view-location.component.ts ~ line 534 ~ ViewLocationComponent ~ verifySitelinkCreds ~ e", e)
        this.sitelinkCredsValid = false;
      })
  }

  showHTMLRowsToAdd() {
    this.newHTMLRow = true;
    this.locationData.htmlHomePageRows.push(new HTMLRow());
  }

  deleteHTMLRow(index) {
    const result = confirm('Are you sure?');
    if (result) {
      this.locationData.htmlHomePageRows.splice(index, 1);
      this.updateLocation();
    }
  }

  saveHTMLRow(e = null) {
    if (this.newHTMLRow == true) {
      if (isUndefined(this.locationData.htmlHomePageRows))
        this.locationData.htmlHomePageRows = new Array<HTMLRow>();

      this.locationData.htmlHomePageRows.push(this.htmlRow);
    }
    else if (isNullOrUndefined(e)) {
      this.locationData.htmlHomePageRows[this.findHTMLRowIndex()] = this.htmlRow;
    }
    else {
      this.selectedHTMLRow = e.data;
      this.locationData.htmlHomePageRows[this.findHTMLRowIndex()] = e.data;
    }
    this.htmlRow = null;
    this.updateLocation();
  }

  findHTMLRowIndex(): number {
    return this.locationData.htmlHomePageRows.indexOf(this.selectedHTMLRow);
  }

  updateUhaulImages(e) {
    console.log(e);
  }

  generateShortUrl() {
    this.shortUrl.generateShortUrl(this.locationData.smsData.linkUrl).toPromise().then((data) => {
      this.locationData.smsData.shortLinkUrl = data.shortUrl;
      this.updateLocation();
    });
  }

  async updateLocation() {
    if (this.locationData.siteLinkCorpCode == 'CCTST') {
      this.locationData.isDemo = true;
    }
    else {
      this.locationData.isDemo = false;
    }

    if (this.checkForLocationAddressChange()) {
      try {
        this.locationData.timezone = await this.mapsService.getTimezoneInfo(this.locationData);
      } catch (e) {
        console.warn('error caught getting timezone info:', e);
        this.afService.openSnackBar(e.message);
      }
    }

    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
      this.afService.updateLocationSmsReminders(this.clientData, this.locationData).then(() => {
        this.afService.openSnackBar('Location successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  checkForLocationAddressChange() {
    if (this.oldLocationData) {
      return (
        this.oldLocationData.address !== this.locationData.address
        || this.oldLocationData.address2 !== this.locationData.address2
        || this.oldLocationData.latitude !== this.locationData.latitude
        || this.oldLocationData.longitude !== this.locationData.longitude
      )
    }

    return false;
  }

  updateIsNoIntegration(e) {
    this.locationData.isNoIntegration = e.checked;
    this.updateLocation();
  }

  updateDisableCustomerPortal(e) {
    this.locationData.disableCustomerPortal = e.checked;
    this.updateLocation();
  }

  updateShowInsuranceOptions(e) {
    console.log(e);
    this.locationData.showInsuranceOptions = e.checked;
    this.updateLocation();
  }

  updateShowInsuranceDescriptions(e) {
    console.log(e);
    this.locationData.showInsuranceDescriptions = e.checked;
    this.updateLocation();
  }

  updateRequireInsurance(e) {
    console.log(e);
    this.locationData.requireInsurance = e.checked;
    this.updateLocation();
  }

  updateShowProtectionPlanInstead(e) {
    console.log(e);
    this.locationData.showProtectionPlanInstead = e.checked;
    this.updateLocation();
  }

  updateHideInsuranceForParkingAndOffices(e) {
    console.log(e);
    this.locationData.hideInsuranceForParkingAndOffices = e.checked;
    this.updateLocation();
  }

  updateHideClientName(e) {
    this.locationData.hideClientName = e.checked;
    this.updateLocation();
  }

  updateSpaceInsteadOfUnit(e) {
    console.log(e);
    this.locationData.spaceInsteadOfUnit = e.checked;
    this.updateLocation();
  }

  updateShowReserveUnitsOption(e) {
    console.log(e);
    this.locationData.showReserveUnitsOption = e.checked;
    this.updateLocation();
  }

  updateSmsReminders(e) {
    console.log(e);
    this.locationData.isSmsReminders = e.checked;
    this.updateLocation();
  }

  updateForceSmsOptIn(e) {
    console.log(e);
    this.locationData.forceSmsOptIn = e.checked;
    this.updateLocation();
  }

  updateDiscountBlurb(e) {
    console.log(e);
    this.locationData.enableDiscountBlurb = e.checked;
    this.updateLocation();
  }

  updateAutoPayAtMoveIn(e) {
    console.log(e);
    this.locationData.isAutoPayAtMoveIn = e.checked;
    this.updateLocation();
  }

  toggleseparatorBar(e) {
    console.log(e);
    this.locationData.showSeparatorbar = e.checked;
    this.updateLocation();
  }

  toggleLoginMetaData(e) {
    console.log(e);
    console.log('event', e.checked);
    this.locationData.loginPageShowMetaData = e.checked;
    this.updateLocation();
  }

  updateShowSocialLinks(event: MdSlideToggleChange) {
    this.locationData.showSocialLinks = event.checked;
    this.updateLocation();
  }

  updateNoGate(event: MdSlideToggleChange) {
    this.locationData.noGate = event.checked;
    this.updateLocation();
  }

  updateAllowPartialPayments(event: MdSlideToggleChange) {
    this.locationData.allowPartialPayments = event.checked;
    this.updateLocation();
  }

  updatePushRateStrikethroughPricing(event: MdSlideToggleChange) {
    this.locationData.pushRateStrikethroughPricing = event.checked;
    this.updateLocation();
  }

  updateIsNotOpen(event: MdSlideToggleChange) {
    this.locationData.isNotOpen = event.checked;
    this.updateLocation();
  }

  updateShowWebRate(event: MdSlideToggleChange) {
    this.locationData.showWebRate = event.checked;
    this.updateLocation();
  }

  updateShowSliderArrows(e: MdSlideToggleChange) {
    this.locationData.showSliderArrows = e.checked;
    this.updateLocation();
  }

  updateSliderAutoPlay(e: MdSlideToggleChange) {
    this.locationData.sliderAutoPlay = e.checked;
    this.updateLocation();
  }

  updateLocationBoxShowSliderArrows(e: MdSlideToggleChange) {
    this.locationData.locationBoxSlideshow.showSliderArrows = e.checked;
    this.updateLocation();
  }

  updateLocationBoxSliderAutoPlay(e: MdSlideToggleChange) {
    this.locationData.locationBoxSlideshow.sliderAutoPlay = e.checked;
    this.updateLocation();
  }

  updateShowPayments(e: MdSlideToggleChange) {
    this.locationData.acceptPayments = e.checked;
    this.updateLocation();
  }

  updateNoOffice(e: MdSlideToggleChange) {
    this.locationData.noOffice = e.checked;
    this.updateLocation();
  }

  updateHideUnits(e: MdSlideToggleChange) {
    this.locationData.hideUnits = e.checked;
    this.updateLocation();
  }

  updateHideRentals(e: MdSlideToggleChange) {
    this.locationData.hideRentals = e.checked;
    this.updateLocation();
  }

  updateHideJoinWaitlist(e: MdSlideToggleChange) {
    this.locationData.hideJoinWaitlist = e.checked;
    this.updateLocation();
  }

  updateHideCallNow(e: MdSlideToggleChange) {
    this.locationData.hideCallNow = e.checked;
    this.updateLocation();
  }

  updateDisableRentals(e: MdSlideToggleChange) {
    this.locationData.disableRentals = e.checked;
    this.updateLocation();
  }

  updateShowAnnouncement(e: MdSlideToggleChange) {
    this.locationData.showAnnouncement = e.checked;
    this.updateLocation();
  }

  updateShowCustomerPortalAnnouncement(e: MdSlideToggleChange) {
    this.locationData.showCustomerPortalAnnouncement = e.checked;
    this.updateLocation();
  }

  updateUseHtmlRow(e: MdSlideToggleChange) {
    this.locationData.useHtmlRow = e.checked;
    this.updateLocation();
  }

  updateReplaceUnitsWithHtmlRow(e: MdSlideToggleChange) {
    this.locationData.replaceUnitsWithHtmlRow = e.checked;
    this.updateLocation();
  }

  updateUseLocationHomePageHtmlRow(e: MdSlideToggleChange) {
    this.locationData.useHomePageHtmlRow = e.checked;
    this.updateLocation();
  }

  updateGateCodeMaxValue(e: MdSlideToggleChange) {
    this.locationData.useGateCodeMaxValue = e.checked;
    this.updateLocation();
  }

  updateAllowHomeInsurancePolicy(e: MdSlideToggleChange) {
    this.locationData.allowHomeInsurancePolicy = e.checked;
    this.updateLocation();
  }

  updateGateCodeMinValue(e: MdSlideToggleChange) {
    this.locationData.useGateCodeMinValue = e.checked;
    this.updateLocation();
  }

  updateAboutLocationSidebarSlider(e: MdSlideToggleChange) {
    this.locationData.aboutLocationSidebarSlider = e.checked;
    this.updateLocation();
  }

  removeSocialLink(index: number) {
    this.locationData.socialLinks.splice(index, 1);
    this.updateLocation();
  }

  removeFeature(index: number) {
    this.locationData.aboutLocationFeaturesArray.splice(index, 1);
    this.updateLocation();
  }

  removeSidebarSection(index: number) {
    this.locationData.locationsCustomSidebarArray.splice(index, 1);
    this.updateLocation();
  }

  updateGateCode(e) {
    console.log(e);
    this.locationData.generateRandomGateCode = e.checked;
    this.updateLocation();
  }

  updateParkingVariables(e) {
    console.log(e);
    this.locationData.parkingVariables = e.checked;
    this.updateLocation();
  }

  updateParkingLienInfo(e) {
    console.log(e);
    this.locationData.parkingLienInfo = e.checked;
    this.updateLocation();
  }

  updateparkingElectricity(e) {
    console.log(e);
    this.locationData.parkingElectricity = e.checked;
    this.updateLocation();
  }

  updateReservationFee(e) {
    console.log(e);
    this.locationData.reservationFee = e.checked;
    this.updateLocation();
  }

  updateHasInsuranceMaxCoverageAmount(e) {
    this.locationData.hasInsuranceMaxCoverageAmount = e.checked;
    this.updateLocation();
  }

  updateShowCheckoutItem(e) {
    console.log(e);
    this.locationData.showCheckoutItem = e.checked;
    this.updateLocation();
  }

  updateUseBoatIconForParking(e) {
    console.log(e);
    this.locationData.useBoatIconForParking = e.checked;
    this.updateLocation();
  }

  updateLeftToolTip(e) {
    console.log(e);
    this.locationData.leftToolTip = e.checked;
    this.updateLocation();
  }

  updateRightToolTip(e) {
    console.log(e);
    this.locationData.rightToolTip = e.checked;
    this.updateLocation();
  }

  updateUseVideoInstead(e) {
    console.log(e);
    this.locationData.useVideoInstead = e.checked;
    this.updateLocation();
  }

  updateUseSlideshowInstead(e) {
    console.log(e);
    this.locationData.useSlideshowInstead = e.checked;
    this.updateLocation();
  }

  updateSortParkingLast(e) {
    console.log(e);
    this.locationData.sortParkingLast = e.checked;
    this.updateLocation();
  }

  updateSortByUnitType(e) {
    console.log(e);
    this.locationData.sortByUnitType = e.checked;
    this.updateLocation();
  }

  updateRentalUseDatePicker(e) {
    console.log(e);
    this.locationData.rentalUseDatePicker = e.checked;
    this.updateLocation();
  }

  updateReservationUseDatePicker(e) {
    console.log(e);
    this.locationData.reservationUseDatePicker = e.checked;
    this.updateLocation();
  }

  updateReservationUseLocationDisabledDays(e) {
    console.log(e);
    this.locationData.reservationUseLocationDisabledDays = e.checked;
    this.updateLocation();
  }

  updateDatePickerUseFutureStartDate(e) {
    console.log(e);
    this.locationData.datePickerUseFutureStartDate = e.checked;
    this.updateLocation();
  }

  updateDatePickerDisableDays(e, index) {
    console.log(e);
    this.locationData.datePickerDisableDays[index] = e.checked;
    this.updateLocation();
  }

  updateReservationUseShortMoveInForm(e) {
    this.locationData.reservationUseShortMoveInForm = e.checked;
    this.updateLocation();
  }

  updateRentalsUseShortMoveInForm(e) {
    this.locationData.rentalsUseShortMoveInForm = e.checked;
    this.updateLocation();
  }

  updateHideReservationsOnUrgency(e) {
    this.locationData.hideReservationsOnUrgency = e.checked;
    this.updateLocation();
  }

  updateHideChangeNameOnPortal(e) {
    this.locationData.hideChangeNameOnPortal = e.checked;
    this.updateLocation();
  }

  updateHideChangeEmailOnPortal(e) {
    this.locationData.hideChangeEmailOnPortal = e.checked;
    this.updateLocation();
  }

  updateDisableTenantUpdateInformation(e) {
    this.locationData.disableTenantUpdateInformation = e.checked;
    this.updateLocation();
  }

  updateUsePtiCore(e) {
    console.log(e);
    this.locationData.usePtiCore = e.checked;
    this.updateLocation();
  }

  updateUseNoke(e) {
    console.log(e);
    this.locationData.useNoke = e.checked;
    this.updateLocation();
  }

  removeAssociationLink(index: number) {
    this.locationData.associationLogos.splice(index, 1);
  }

  updateSmsReviewLinkUrl() {
    this.locationData.sms_review_link_url = this.locationData.smsReviewLinkUrl;
    this.updateLocation();
  }

  async getLocationOnboardingInfo() {
    let hubspot = [], locationInformation = [], data = await this.afService.getOnboardingLocation(this.locationData.onboardingKey, this.key, this.locKey);
    console.log(data)
    _.each(data.hubspot, (v, k) => hubspot.push({ key: k, val: v }));
    _.each(data.locationInformation, (v, k) => locationInformation.push({ key: k, val: v }));
    this.locationOnboardingInfo = {
      hubspot: hubspot,
      locationInformation: locationInformation
    };
  }

  sendText() {
    this.loading.showLoading();
    this.error = '';
    this.success = '';
    if (isNullOrUndefined(this.locationData.smsData.phoneNumber) || this.locationData.smsData.phoneNumber == '') {
      this.error = 'You must select a Twilio number, dummy.';
      this.loading.hideLoading();
    }
    else {
      this.testSms.from = this.locationData.smsData.phoneNumber;
      console.log(this.testSms);

      this.afService.saveObjectToFacilityFirebase(this.clientData.code, this.testSms, 'textMessage').toPromise().then((data) => {
        console.log(data);
        this.success = 'Text Message Sent';
        this.loading.hideLoading();
      }).catch(e => {
        this.error = e;
        this.loading.hideLoading();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/view-location/view-location.component.ts